export const SelectType = ["cafe", "restaurant", "bar", "lounge"];

export const Progress = ["initiated", "documents_submitted", "under_review", "completed"];

export const Approval = ["pending", "approved", "rejected"];

export const GEO = "AIzaSyBaw2eolMvHQq6Wkzh4HT77AnIg2Ud6ejc";

